import {emphasize} from '@mui/material/styles';

/**
 * Global and Material-UI overrides based on designs and pairing
 * We use the theme as a param to make the switch between dark and light easier
 * @param {*} theme - theme to be used as baseline
 */
export const getStyleOverrides = theme => {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: theme.palette.grey[500],
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          backgroundColor: 'transparent',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        sizeSmall: {
          padding: 7, // we want it square and matching material-ui spec
        },
      },
    },
    MuiLink: {
      defaultProps: {
        variant: 'inherit',
        underline: 'hover',
      },
    },
    MuiSlider: {
      styleOverrides: {
        markLabel: {
          top: 20,
        },
      },
    },
    MuiChip: {
      defaultProps: {
        size: 'small',
        shape: 'square',
        variant: 'light',
      },
      styleOverrides: {
        root: ({ownerState, theme}) => {
          const getColor = color =>
            theme.palette.mode === 'light' ? color.dark : color.light;
          return {
            ...(ownerState.variant === 'light' &&
              ownerState.color !== 'default' && {
                backgroundColor:
                  theme.palette[ownerState.color][theme.palette.mode],
                color: getColor(theme.palette[ownerState.color]),
                '&.MuiChip-clickable:hover': {
                  backgroundColor: emphasize(
                    theme.palette[ownerState.color][theme.palette.mode],
                    0.1
                  ),
                },
              }),
          };
        },
        icon: ({ownerState, theme}) => ({
          marginRight: ownerState.label
            ? theme.spacing(-0.5)
            : theme.spacing(0.5),
        }),
        label: ({ownerState, theme}) => ({
          paddingRight: ownerState.label ? theme.spacing(1) : 0,
          paddingLeft: ownerState.label ? theme.spacing(1) : 0,
        }),
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          '& .MuiSwitch-switchBase.Mui-disabled+.MuiSwitch-track': {
            opacity: 1,
          },
        },
      },
    },
  };
};
